module.exports = __webpack_public_path__ + "img/ctrl-swap-stub-down--.33eb28ec.svg";